// extracted by mini-css-extract-plugin
export default {"page":"amir_","container":"BtX9s","inner":"EZKuz","content":"Ykc8_","title":"F421R","text":"kEoDH","button":"rSZjz","icon":"TKYd1"};